import {TBaseModel, TListBaseModel} from './common/t-base.model';
import {AutoMap} from '@automapper/classes';
import {FormField} from '../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';
import {SourceTypeEnum, sourceTypeEnumToGeneralTypeModel} from '../enums/source-type.enum';
import {
  SourceReviewFrequencyWeightTypeEnum,
  sourceReviewFrequencyWeightTypeEnumToGeneralTypeModel
} from '../enums/source-review-frequency-weight-type.enum';

export class SourceListModel extends TListBaseModel {
  @AutoMap()
  title!: string;
  @AutoMap()
  type!: SourceTypeEnum | null;
  @AutoMap()
  author!: string;
  @AutoMap()
  isStarred: boolean = false;
}

export class SourceModel extends TBaseModel {
  @FormField({
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  title!: string;

  @FormField({
    default: '',
    validators: []
  })
  @AutoMap()
  author!: string;

  @FormField({
    type: 'select',
    selectTypeValues: Object.values(SourceTypeEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: sourceTypeEnumToGeneralTypeModel,
    default: SourceTypeEnum.Book,
    validators: []
  })
  @AutoMap()
  type!: SourceTypeEnum | null;

  @FormField({
    type: 'select',
    previewName: 'Review Frequency Weight',
    selectTypeValues: Object.values(SourceReviewFrequencyWeightTypeEnum).filter((v): v is number => typeof v === 'number') as number[],
    selectTypeEnumGeneralModelFunction: sourceReviewFrequencyWeightTypeEnumToGeneralTypeModel,
    default: SourceReviewFrequencyWeightTypeEnum.Medium,
    validators: []
  })
  @AutoMap()
  reviewFrequencyWeightType!: SourceReviewFrequencyWeightTypeEnum | null;

  @FormField({
    default: '',
    validators: []
  })
  @AutoMap()
  description!: string;

  @FormField({
    default: '',
    validators: []
  })
  @AutoMap()
  url!: string;

  @FormField({
    type: 'toggle',
    previewName: 'Favorite',
    default: false,
    validators: []
  })
  @AutoMap()
  isStarred: boolean = false;
}
